module.exports = __webpack_public_path__ + "static/fonts/icomoon.ec57d8f9.eot";